import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { RevealOnScroll } from "./RevealText";
import { useLanguage } from "../i18n/LanguageContext";

export function FAQ() {
  const { t } = useLanguage();
  return (
    <section id="faq" className="relative py-24 lg:py-32 bg-[#050505]" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <RevealOnScroll className="mb-14">
          <span className="font-mono-data text-xs text-[#00F0FF]">/ {t.nav.faq}</span>
          <h2 className="mt-4 font-display font-bold text-4xl sm:text-5xl text-white tracking-tighter">
            {t.faq.title}
          </h2>
          <p className="mt-4 text-zinc-400 text-base sm:text-lg">{t.faq.subtitle}</p>
        </RevealOnScroll>

        <RevealOnScroll delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {t.faq.items.map((item, i) => (
              <AccordionItem key={item.question} value={`item-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-display font-medium text-white hover:text-[#00F0FF] text-base sm:text-lg py-6">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-zinc-400 text-sm sm:text-base leading-relaxed pb-6">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </RevealOnScroll>
      </div>
    </section>
  );
}
